import request from '@/utils/request'
// 新增邦奇设置
export function setupBangqi(data) {
  return request({
    url: '/super/setupBangQi',
    method: 'post',
    data,
  })
}

// 获取邦奇配置
export function getBangqi(params) {
  return request({
    url: '/super/getBangQiConfig',
    method: 'get',
    params,
  })
}

// 获取赛邮配置
export function getSaiYou(params) {
  return request({
    url: '/super/getSubmailConfig',
    method: 'get',
    params,
  })
}

// 设置赛邮配置
export function setSaiYou(data) {
  return request({
    url: '/super/setupSubmail',
    method: 'post',
    data,
  })
}

// 获取抖店配置
export function getDouDian(params) {
  return request({
    url: '/super/getDouDianConfig',
    method: 'get',
    params,
  })
}

// 设置抖店配置
export function setDouDian(data) {
  return request({
    url: '/super/setupDouDian',
    method: 'post',
    data,
  })
}

// 获取配置
export function getAppConfig(params) {
  return request({
    url: '/super/getAppConfig',
    method: 'get',
    params,
  })
}